import React, { useState, useEffect } from 'react';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import {  FaQuoteRight } from 'react-icons/fa';
import "./css/Experience.css"
import {ratings,jobs} from './data.js';
import Footer from "./Footer.js"
import Next from "./Next.js"
import AOS from 'aos';
function Experience() {
  AOS.init();
  const [people,setPeople]=useState(jobs)
  const [rating,setRating]=useState(ratings)
  const [index,setIndex]=useState(0)
  console.log(rating)
  useEffect(()=>{
    const lastIndex=people.length-1
    if(index<0){
      setIndex(lastIndex)
      console.log(index,lastIndex)
    }
    if(index>people.length-1){
      setIndex(0)
    }
  },[index,people])
  useEffect(()=>{
    let Slider=setInterval(()=>{
      setIndex(index+1)
    },10000);
    return()=>clearInterval(Slider)
  },[index])
  return (
  <>
  <section className="section1">
    <div data-aos="fade-up"  
        data-aos-duration="3000" className="title1">
      <h2>
        <span>/</span>Previous Jobs
      </h2>
    </div>
    <div data-aos="fade-up"  
        data-aos-duration="3000" className="section-center1">
      {people.map((person,personIndex)=>{
        const {image,title,id,name,quote,time}=person;
        let position="nextSlide something"
        if(personIndex===index){
          position="activeSlide something"
        }
        if(personIndex===index-1 ||(index===0 && personIndex===people.length-1) ){
          position="lastSlide  something"
        }
        return <article className={position} key={id}>
          <img className="person-img" src={image} alt={name}/>
          <h4>{name}</h4>
          <p className="title1">{title}</p>
          <p className="text1">{quote}</p>
          <time className="text1">{time}</time>
          <FaQuoteRight className="icon1"/>
        </article>
      })}
      <button onClick={()=>{setIndex(index-1)}} className="prev1">
        <FiChevronLeft/>
      </button>
      <button onClick={()=>{setIndex(index+1)}} className="next1">
        <FiChevronRight/>
      </button>
    </div>
    
  </section>
  
    <section className="skills">
      <div className="ratings-container">
        <h1>My Ratings And Skills</h1>
      </div>
        <div className="ratings-container">
          {rating.map((item,index)=>{
            const {name,value}=item;
            return(
            <div>
              <div key={index} className="full-container">
                <div className="full" style={{height:`${value}%`, width: "100%"}}>
                  <p>{name}</p>
                  <p>{value}%</p>
                </div>
                
              </div>
            </div>
            );
          })}
        </div>
    </section>
    <Next   name="Contact" href="./contact" back="Projects" href2="/projects" isAbout={true} islast={true}/>
  <Footer/>
  </>
  );
}

export default Experience
